import script from "./ProdutoMapaEditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ProdutoMapaEditPage.vue?vue&type=script&setup=true&lang=js"

import "./ProdutoMapaEditPage.vue?vue&type=style&index=0&id=4a05c896&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a05c896"]])

export default __exports__